import React from "react";
import PropTypes from "prop-types";
import queryString from 'query-string';
import Checkbox from "../../common/checkbox/main";

import './styles/organization_search_bar.scss';

class SearchBar extends React.Component {
  state = {
    value: this.inputValue,
    focused: false,
    opened: true,
    hovering: false,
    orgOpened: true,
    isStrict: this.isStrict
  };

  componentDidMount() {
    const { query } = this.props;
    const previousUrl = this.getCookie("previousUrl");
    if (previousUrl && previousUrl.indexOf("search?q") > -1) {
      this.setCookie("previousUrl");
      this.setState({ opened: true });
    } else if (window.location.search.length === 0) {
      this.setCookie("parentUrl");
    }
    if (query) {
      this.setState({ value: query });
    }
  }

  get inputValue() {
    return this.props.query ? this.props.query : "";
  }

  get orgOpened() {
    return Boolean(this.props.query);
  }

  get isStrict() {
    return window.location.href.split('strict_search=')[1] === "true";
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts
        .pop()
        .split(";")
        .shift();
    }

    return undefined;
  }

  setCookie(name) {
    document.cookie = `${name}=${window.location.href}; path=/`;
  }

  handleChange(e) {
    if (e.target.value.indexOf(",") > -1) {
      this.setState({ value: this.handleCommaSeparatedSearch(e) });
    } else {
      this.setState({ value: e.target.value });
    }
  }

  handleCommaSeparatedSearch(e) {
    return e.target.value.replace(/\s*,\s*/g, " || ");
  }

  handleFocus() {
    this.setState({ focused: true });
  }

  handleBlur() {
    if (!this.state.value && window.location.search.length > 0) {
      this.redirectToOrgs();
    }
    this.setState({ focused: false });
  }

  toggleStrictSearch() {
    this.setState((state) => (
      { isStrict: !state.isStrict }
    ), () => {
      this.handleSearch();
    });
  }

  adjustSearch() {
    const term = "FindAll: ";
    const query = this.state.value;
    let removedTerm = query.substring(term.length, query.length);
    removedTerm = removedTerm.split(" || ").join(" ");
    return `"${removedTerm.split(" ").join('" || "')}"`;
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.handleSearch();
    }
  }

  handleSearch() {
    const { isStrict, value } = this.state;
    const { slug, restricted } = this.props;
    const params = queryString.parse(window.location.search);
    if (!value && window.location.search.length > 0) {
      this.redirectToOrgs();
    } else if (value.length > 0 && value.startsWith("FindAll: ")) {
      window.location = `/organizations/${slug}/search?q=${this.adjustSearch()}${isStrict ? "&strict_search=true" : ''}`;
    } else if (BFG.embedView) {
      // Printui Iframe
      window.location = `/organizations/${slug}/embedded_search?embed=printui&q=${value}${isStrict ? "&strict_search=true" : ''}${restricted ? "&restricted=true" : ''}${params.printui_frame ? `&printui_frame=${params.printui_frame}` : ""}`;
    } else if (value.length > 0) {
      window.location = `/organizations/${slug}/search?q=${value}${isStrict ? "&strict_search=true" : ''}`;
    }
  }

  redirectToOrgs() {
    if (BFG.embedView) { return; }
    this.setCookie("previousUrl");
    const url = this.getCookie("parentUrl") || `/organizations`;
    window.location = url;
  }

  render() {
    if (BFG.downloadAlertEnabled) {
      // hide org search if org has a brandfolder/collection with download alerts enabled
      return null;
    }

    const { value } = this.state;
    return (
      <div className="organization-search-bar-component org-search open">
        <div className={`strict-toggle ${value.length > 0 ? 'visible' : 'hidden'}`}>
          <Checkbox
            checked={this.state.isStrict}
            size="md"
            toggle={() => this.toggleStrictSearch()}
            label={t("Strict Search")}
          />
        </div>
        <div className="s-search-input-container s-search-focus">
          <div className="search-input-container">
            <input
              id="brandfolderSearch"
              type="text"
              className="searchbar org-search"
              placeholder={`${t("Search")}`}
              value={this.state.value}
              onChange={this.handleChange.bind(this)}
              onFocus={() => this.handleFocus()}
              onBlur={() => this.handleBlur()}
              onKeyPress={this.handleKeyPress.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

SearchBar.propTypes = {
  slug: PropTypes.string,
  query: PropTypes.string,
  restricted: PropTypes.bool
};

export default SearchBar;
